import React, { useState, useContext, useEffect } from 'react';
import { Container, List, Typography, Button } from '@mui/material';
import Layout from '../../component/Layout';
import { UserProfile } from '../../contexts/UserContext';
import { SystemProfile } from '../../contexts/SystemContext';
import api from '../../connection/Axios';


const ListarAdministradores = () => {
  const [userData, setUserData] = useContext(UserProfile)
  const [systemData, setSystemData] = useContext(SystemProfile)
  const [adminUsers, setAdminUsers] = useState([])

  const headers = {
    headers: {
      "Content-Type": "application/json", "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${userData.token}`
    }};

    async function GetAdminUsers() {
      api.get('get/getAdmin/', headers).then(response => {
        setAdminUsers((response.data).filter(user => user.role === 'admin'))
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
      })
    }
    
    useEffect(()=>{
      GetAdminUsers()
    }, [])


    async function DeleteUser(username) {
      await api.post('auth/deleteUser', {username: username}, headers).then(response => {
        GetAdminUsers()
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, typeError: 'error'})
      })
    }



  return (
    <>
        <Layout breadcrumb='Dashboard / Administradores / Listar administradores' title='Listar Usuários Admin'>
        <Typography>Usuários ADMINISTRADORES do sistema EHS:</Typography>
          <br />
          <div style={styles.list}>
            {adminUsers?.map((adm, index)=>(
              <div className='listItem' style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                <div style={({width: 200})}>
                  {adm.name}
                </div>
                <div style={({width: 200})}>
                  {adm.username}
                </div>
                <Button variant="outlined" disableElevation color="error" size='small' onClick={()=>{DeleteUser(adm.username)}}>Remover</Button>
            </div>
            ))}
          </div>
        </Layout>
    </>
  );
};

export default ListarAdministradores



const styles = {
  list: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 20
  }
}